module.exports = __webpack_public_path__ + "77346ad5a8aab02ce7ec015b9fb3f03a.png";